import type { FunctionComponent } from 'react'
// import './styles.css'
import { MuiTheme } from './MuiTheme'

export const ThemeProvider: FunctionComponent<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <MuiTheme>{children}</MuiTheme>
}
